module.exports = __webpack_public_path__ + "img/fastForward.8242665e.svg";